/**
 * @desc 列表
 */
const URL = "/rantion-mns";
import http, { updateResponse } from "@/http";
export function request(body: defs.mns.MessageNoticeUserRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/messageNoticeUser/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
